export default "__VITE_ASSET__BYW_7Vpo__"